module.exports = __webpack_public_path__ + "static/media/iso.df257b58.svg";